/**
 * CTA final du closer produit.
 *
 * Comme la barre collante, il n'ajoute pas au panier : il ramène à la zone de
 * choix, où le pack, le coloris et la taille sont visibles avant l'achat.
 */
class ProductCloserCta extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.scrollToTarget);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.scrollToTarget);
  }

  scrollToTarget = () => {
    const target = document.querySelector(this.dataset.target || '');
    if (!target) return;

    const offset = parseInt(this.dataset.offset || '0', 10);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });
  };
}

if (!customElements.get('product-closer-cta')) customElements.define('product-closer-cta', ProductCloserCta);
